module.exports = __webpack_public_path__ + "img/more.69fb4091.svg";